import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { sanitizeFormInput } from '../../utils/inputSanitization';
import './PasswordInput.scss';

const PasswordInput = ({
  value,
  onChange,
  placeholder = 'Password',
  name = 'password',
  className = '',
  style = {},
  showStrength = false,
  onStrengthChange,
  disabled = false,
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (e) => {
    const sanitizedValue = sanitizeFormInput(e.target.value);
    onChange({
      target: {
        name: e.target.name,
        value: sanitizedValue
      }
    });
  };

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const handleFocus = (e) => {
    setIsFocused(true);
    if (props.onFocus) props.onFocus(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    if (props.onBlur) props.onBlur(e);
  };

  return (
    <div className={`password-input-container ${className}`}>
      <div className={`password-input-wrapper ${isFocused ? 'focused' : ''}`}>
        <input
          type={isVisible ? 'text' : 'password'}
          name={name}
          value={value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={placeholder}
          disabled={disabled}
          className="password-input"
          style={style}
          {...props}
        />
        <button
          type="button"
          className="password-toggle"
          onClick={toggleVisibility}
          disabled={disabled}
          tabIndex={-1}
          aria-label={isVisible ? 'Hide password' : 'Show password'}
        >
          {isVisible ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
    </div>
  );
};

export default PasswordInput;
